import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pageView } from '../lib/analytics'

export function PageViewTracker() {
  const location = useLocation()
  useEffect(() => {
    pageView(window.location.href)
  }, [location.pathname, location.search])
  return null
}
